import {Component, Input, OnInit} from '@angular/core';
declare var jQuery: any;


@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {

  @Input('dados')dados:any;
  tabela:any;

  constructor() { }


  ngOnInit() {
      console.log(this.dados);
      let that=this;
      if(this.dados!=Array){
          this.tabela = Object.keys(this.dados).map(function(key) {
              return [Number(key), that.dados[key]];
          });

      }else{
          this.tabela=this.dados;
      }
      console.log(this.tabela);
      document.getElementById("tabela").
      appendChild(this.criarTabela(this.tabela));
  }

    criarTabela(conteudo) {
        var tabela = document.createElement("table");
        var thead = document.createElement("thead");
        var tbody=document.createElement("tbody");
        var thd=function(i){return (i==0)?"th":"td";};
        for (var i=0;i<conteudo.length;i++) {
            var tr = document.createElement("tr");
            for(var o=0;o<conteudo[i].length;o++){
                var t = document.createElement(thd(i));
                var texto=document.createTextNode(conteudo[i][o]);
                t.appendChild(texto);
                tr.appendChild(t);
            }
            (i==0)?thead.appendChild(tr):tbody.appendChild(tr);
        }
        tabela.appendChild(thead);
        tabela.appendChild(tbody);
        return tabela;
    }


}



// WEBPACK FOOTER //
// ./src/app/table/table.component.ts